import { render, staticRenderFns } from "./BoxAtividadesPendentes.vue?vue&type=template&id=d34a0f4c"
import script from "./BoxAtividadesPendentes.vue?vue&type=script&lang=js"
export * from "./BoxAtividadesPendentes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports